export default __webpack_public_path__ + "static/SR USA - Natural - Statement-964bb244d40964034eecb2448b6df2fa.pdf";